
$(function () {
  let $circleNavIcons = $(".circle-nav-icons li");
  let $menuNav = $(".menu-nav");
  let $menuTtlImg = $('.menu-ttl img');
  let $menuCloseImg = $('img.menu-close');
  let subw, wh, menuTtlWidth, $menuCloseWidth;
  let isOpen = false;

  function menuCloseAction() {
    isOpen = true;
    $menuNav.removeClass('active');
    $('body').removeClass('overflow');

    $contentMenu.fadeOut(function () {
      $circleNav.css({ width: subw + 'px' });
      $menuTtlImg.css({ width: menuTtlWidth + 'px' });
      $menuCloseImg.css({ width: $menuCloseWidth + 'px' });

      $circleNavIcons.each(function (i) {
        $(this).delay(100 * i).queue(function (next) {
          let tr = { 'transform': '', 'opacity': '0' };
          $(this).css(tr);
          next();
        });
        if (i == $circleNavIcons.length - 1) {
          isOpen = false;
        }
      });
    });
  }

  //スムーススクロール
  $('a[href^="#"]').click(function () {
    menuCloseAction();

    // スクロールの速度
    let speed = 400; // ミリ秒で記述
    let href = $(this).attr("href");
    let target = $(href == "#" || href == "" ? 'html' : href);

    console.log('target:', href);
    let targetId = target.attr('id')
    switch (href) {
      case '#group7':
      case '#group10':
      case '#group11':
      case '#group12':
        console.log('hoge');
        $('.type-hero').fadeOut();
        $('.type-villain').fadeIn(function () {
          setTimeout(function () {
            let position = target.offset().top;
            $('body').removeClass('fixed');
            $('body').removeClass('overflow');
            $('body,html').animate({ scrollTop: position }, speed, 'swing');
          }, 500);
        })
        break;
      case '#top':
        let position = target.offset().top;
        $('body').removeClass('fixed');
        $('body').removeClass('overflow');
        $('body,html').animate({ scrollTop: position }, speed, 'swing');
        break;
      default:
        $('.type-villain').fadeOut();
        $('.type-hero').fadeIn(function () {
          setTimeout(function () {
            let position = target.offset().top;
            $('body').removeClass('fixed');
            $('body').removeClass('overflow');
            $('body,html').animate({ scrollTop: position }, speed, 'swing');
          }, 500);
        })
        break;
    }
    return false;
  });

  $(window).resize(function () {
    if ($menuNav.hasClass('active')) {
      menuCloseAction();
    }
  });

  $('.menu-nav, .btn-close, .menu-close, circle-nav-list li').on('click', function () {
    if (isOpen) { return false; }
    $('#menu-group .action-text').fadeOut();
    $('#menu-group .action-text').removeClass('animated2 text-shake');
    $('#menu-group #menu-nav .frog').removeClass('animated swing');

    wh = $(window).innerHeight(); // 開いたときの高さ取得
    subw = subw ? subw : $circleNav.innerWidth(); // 開いたときの高さ取得
    menuTtlWidth = menuTtlWidth ? menuTtlWidth : $menuTtlImg.innerWidth(); // 開いたときの高さ取得
    $menuCloseWidth = $menuCloseWidth ? $menuCloseWidth : $menuCloseImg.innerWidth(); // 開いたときの高さ取得


    if ($menuNav.hasClass('active')) {
      menuCloseAction();
    } else {

      $menuNav.addClass('active');
      $('body').addClass('overflow');
      let circlePosition = Math.floor((wh / 4)) < 300 ? Math.floor((wh / 4)) : 300; //中央画像の幅で全体のサイズが変更される
      if ((Math.floor((wh / 4)) < 230)) { // ボタン用の横幅
        $menuTtlImg.css({ width: ($menuTtlImg.innerWidth() - 50) + 'px' });
        $menuCloseImg.css({ width: ($menuCloseImg.innerWidth() - 60) + 'px' });
      } else {
        $menuTtlImg.css({ width: '100%' });
        $menuCloseImg.css({ width: '100%' });
      }// endif
      $circleNav.css({ width: (wh / 4) + 'px' });

      $contentMenu.fadeIn(function () {
        $circleNavIcons.each(function (i) {
          $(this).delay(100 * i).queue(function (next) {
            let count = (30 * i);
            let count2 = (-30 * i);
            let tr = { 'transform': 'rotate(' + count + 'deg) translate(0, -' + circlePosition + 'px) rotate(' + count2 + 'deg) translate(-50%,-50%)', 'opacity': '1' };
            $(this).css(tr);
            next();
          });
        });
      });
    }

    return false;
  });
});